<template>
    <v-bottom-sheet v-model="visible" persistent>
        <v-sheet class="text-center"
                 height="200px">
            <v-btn class="mt-6"
                   text
                   color="red"
                   @click="onClose">
                close
            </v-btn>
            <div >
               <v-container>
                   <v-row>
                       <v-col cols="12" lg="3" md="3" sm="4">
                           <v-card ma-5 mt-8 hover>
                               <word-cloud-chart :title="previewWordCloudChart.title"
                                                 :data="previewWordCloudChartData"
                                                 height="120px"
                                                 v-show="previewWordCloudChartData && !isWordCloudChartLoading"
                                                 :colors="previewWordCloudChart.colors"></word-cloud-chart>
                           </v-card>
                       </v-col>
                   </v-row>
               </v-container>
            </div>
        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
    import WordCloudChart from "../../components/charts/WordCloudChart"

    export default {
        name: 'ChartSelector',
        data: function () {
            return {
                previewLineChart: {},
                previewWordCloudChart: {
                    title: null
                },
                previewWordCloudChartData: "",
                previewLineChartData: [],
                isWordCloudChartLoading: true,
                isLineChartLoading: true,
                isChartSelectorVisible: false
            }
        },
        components: {
            WordCloudChart
        },
        props: {
            visible: {
                default: false,
                type: Boolean
            }
        },
        created() {
            this.setup();
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
                await this.getWordCloudChart();
            },
            async onClose() {
                this.$emit('on-close');
            },
            async getWordCloudChart() {
                const chartDetails = JSON.parse(localStorage.getItem("previewWordCloudChart"));
                this.isWordCloudChartLoading = true;

                if (!chartDetails) return;
                this.previewWordCloudChart = chartDetails;

                if (this.previewWordCloudChart) {
                    this.previewWordCloudChartData = "Demo Demo Demo test word test words wrdee best fred get set met fret let drain Demo test test";
                    this.isWordCloudChartLoading = false;
                }
            },
           
        },
    }
</script>
